<template>
  <div class="dropdown br-dropdown">
    <label v-if="showLabel" class="form-label" data-tool-tip="showInfoIcon">
      <span class="+float-left">{{ title }}</span>
      <info-icon v-if="showInfoIcon"></info-icon>
    </label>
    <p
      class="dropdown__selected selected selectedTitle +text-left +mg-bottom-none"
      v-bind:class="{ '--is-active': isExpanded, '--disabled': disabled }"
      v-on:click.stop="toggleAction"
    >
      {{ selectedText }}
      <svg
        class="dropdown__arrow"
        width="13px"
        height="13px"
        viewBox="0 0 13 13"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
      >
        <g
          id="Page-1"
          stroke="none"
          stroke-width="1"
          fill=""
          fill-rule="evenodd"
        >
          <g id="Icons" transform="translate(-340.000000, -38.000000)" fill="">
            <g
              id="dropdown-arrow-inactive"
              transform="translate(340.000000, 38.000000)"
            >
              <path
                id="Combined-Shape"
                d="M6.86396103,10.9497475 L6.86396103,0 L5.86396103,0 L5.86396103,
                            10.9497475 L0.707106781,5.79289322 L0,6.5 L6.36396103,12.863961 L6.71751442,12.5104076 L12.7279221,
                            6.5 L12.0208153,5.79289322 L6.86396103,10.9497475 Z"
              ></path>
            </g>
          </g>
        </g>
      </svg>
    </p>
    <div
      class="dropdown__list-wrapper br-dropdown-container"
      v-show="isExpanded"
    >
      <div class="dropdown__list-container">
        <ul class="list-bare +mg-none">
          <li
            v-for="(item, index) in items"
            :key="index"
            class="dropdown__list-item"
            v-bind:class="isSelected(item) ? 'selected' : ''"
            v-on:click.stop="itemClickedAction(item)"
          >
            <span class="dropdown__input-label">{{ item.name }}</span>
          </li>
        </ul>
      </div>
      <div v-if="multi" class="multi-select-action">
        <button
          class="button --primary --full-width"
          type="button"
          v-on:click="toggleAction"
        >
          {{ updateButtonText }}
        </button>
      </div>
    </div>
  </div>
</template>
<style scoped>
li.selected {
  background: #3139f2;
  color: #fff;
}
</style>

<script>
//@todo - this component is not fully tested for multi-select.
import infoIcon from 'apps/legacy-components/rt-info.vue'
import calculatorEventBus from 'apps/bankrate-calculators/events'
import { isEmpty, map } from 'lodash'

export default {
  components: { infoIcon },
  props: {
    uniqueId: { type: String, default: 'dropdown' },
    trackingName: {
      type: String,
      default: ''
    },
    title: { type: String, default: '' },
    showLabel: { type: Boolean, default: false },
    showInfoIcon: { type: Boolean, default: false },
    multi: { type: Boolean, default: false },
    items: {
      default: () => {
        return []
      }
    },
    defaultValue: { type: String, default: '' }, // value of single selection default item
    multiDefaultValues: {
      default: () => {
        return []
      }
    },
    displaySelectionCount: { type: Boolean, default: true }, // Display count if multi-selected items
    multiOptionText: { type: String, default: 'Elements' },
    updateButtonText: { type: String, default: 'UPDATE' },
    copy: {
      default: () => {
        return []
      }
    }, // The tooltip data
    disabled: { type: Boolean, default: false },
    callback: {
      type: String,
      default: 'setDropDownValue'
    }
  },
  data() {
    return {
      isExpanded: false,
      selection: []
    }
  },
  computed: {
    fieldName() {
      return this.trackingName ? this.trackingName : this.title.toLowerCase()
    },
    hasSelection() {
      return !!this.selection.length
    },
    selectedText() {
      if (this.multi) {
        return this.displaySelectionCount
          ? `${this.multiOptionText} ${this.selection.length}`
          : ''
      } else {
        return this.selection.length ? this.selection[0].name : ''
      }
    }
  },
  methods: {
    getSelectedItems() {
      return this.items.filter(function(x) {
        return x.selected
      })
    },
    getItemIndexFromName(name) {
      return this.items
        .map(function(x) {
          return x.name
        })
        .indexOf(name)
    },
    setSingleSelectValue(name) {
      const itemIndex = this.getItemIndexFromName(name)
      this.items.map(row => {
        row.selected = false
      })
      this.items[itemIndex].selected = true
      if (!this.multi) {
        this.notifyChanges()
      }
    },
    setDefaultValue() {
      if (!this.multi && this.defaultValue !== '') {
        // single
        this.setSingleSelectValue(this.defaultValue)
      } else if (this.multi && !isEmpty(this.multiDefaultValues)) {
        this.multiDefaultValues.forEach(name => {
          this.setSingleSelectValue(name)
        })
        this.notifyChanges()
      }
    },
    notifyChanges() {
      this.selection = this.getSelectedItems()
      this.$store.dispatch(this.callback, {
        name: this.uniqueId,
        value: this.selection
      })
    },
    toggleAction() {
      if (this.disabled) {
        this.isExpanded = false
        return
      }
      if (this.isExpanded) {
        this.notifyChanges()
        this.isExpanded = false
        calculatorEventBus.$emit('fieldChanged', {
          fieldName: this.fieldName,
          value: map(this.selection, 'name').join(',')
        })
      } else {
        this.isExpanded = true
        calculatorEventBus.$emit('dropDownOpened', this.uniqueId)
      }
    },
    isSelected(item) {
      return item.hasOwnProperty('selected') && item.selected === true
    },
    itemClickedAction(item) {
      const itemIndex = this.items
        .map(function(x) {
          return x.value
        })
        .indexOf(item.value)

      if (this.multi) {
        this.items[itemIndex].selected = !this.items[itemIndex].selected
      } else {
        this.items.map(row => {
          row.selected = false
        })
        this.items[itemIndex].selected = true
        this.toggleAction()
      }
    }
  },
  created() {
    this.setDefaultValue()
    let vm = this
    window.document.addEventListener('click', e => {
      if (!e.target.classList.contains('br-dropdown')) {
        vm.isExpanded = false
      }
    })
  }
}
</script>
